import { render, staticRenderFns } from "./SchoolPopulation.vue?vue&type=template&id=2b166876&scoped=true&"
import script from "./SchoolPopulation.vue?vue&type=script&lang=js&"
export * from "./SchoolPopulation.vue?vue&type=script&lang=js&"
import style0 from "./SchoolPopulation.vue?vue&type=style&index=0&id=2b166876&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b166876",
  null
  
)

export default component.exports